import type { HTMLAttributes } from 'react';
import { Heading, Text } from '@ksyos/design-system';
import { styled } from 'styled-components';
import { IntroContainer } from '../../molecules/introContainer/IntroContainer';

export interface IPageIntroProps extends HTMLAttributes<HTMLDivElement> {
    subtitle?: string;
    title: string;
}

export function PageIntro(props: IPageIntroProps) {
    return (
        <BackgroundColor>
            <IntroContainer>
                <Heading
                    mb={4}
                    size="xlarge"
                >
                    {props.title}
                </Heading>
                {props.subtitle && <Text>{props.subtitle}</Text>}
            </IntroContainer>
        </BackgroundColor>
    );
}

export const BackgroundColor = styled.div`
    background-color: white;
`;
